{
  "name": "@reservoir0x/reservoir-kit-ui",
  "description": "ReservoirKit is the official frontend kit to get you started building dApps with the ReservoirProtocol.",
  "version": "1.18.10",
  "author": "Reservoir Protocol",
  "license": "MIT",
  "exports": {
    ".": {
      "import": "./dist/index.mjs",
      "require": "./dist/index.js",
      "types": "./dist/index.d.ts"
    }
  },
  "source": "./src/index.ts",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "files": [
    "dist"
  ],
  "keywords": [
    "nft",
    "reservoir",
    "reservoirkit",
    "protocol",
    "sdk"
  ],
  "sideEffects": false,
  "scripts": {
    "clean": "rm -rf dist",
    "version": "yarn version",
    "version:package": "sh ../../scripts/package-version.sh",
    "version:update": "yarn version ${0}; PACKAGE_VERSION=$(yarn version:package); git add -A; git commit -m \"🎉 Release ui package v$PACKAGE_VERSION\"; git tag v${PACKAGE_VERSION}-UI; git push --tags;",
    "version:prerelease": "yarn version prerelease; RC_VERSION=$(yarn version:package); git add -A; git commit -m \"✨ Prerelease ui package v$RC_VERSION\"; git tag v${RC_VERSION}-UI; git push --tags;",
    "changelog": "node ../../scripts/generate-changelog.js package=ui"
  },
  "dependencies": {
    "@fortawesome/fontawesome-svg-core": "^6.1.1",
    "@fortawesome/free-solid-svg-icons": "^6.1.1",
    "@fortawesome/react-fontawesome": "^0.2.0",
    "@radix-ui/colors": "^0.1.8",
    "@radix-ui/react-collapsible": "1.0.3",
    "@radix-ui/react-dialog": "1.0.4",
    "@radix-ui/react-dropdown-menu": "2.0.5",
    "@radix-ui/react-popover": "1.0.6",
    "@radix-ui/react-scroll-area": "1.0.4",
    "@radix-ui/react-select": "1.2.2",
    "@radix-ui/react-switch": "1.0.3",
    "@radix-ui/react-toggle-group": "1.0.4",
    "@radix-ui/react-tooltip": "1.0.6",
    "@react-hookz/web": "^19.2.0",
    "@reservoir0x/reservoir-sdk": "workspace:*",
    "@stitches/react": "1.3.1-1",
    "dayjs": "^1.11.4",
    "flatpickr": "^4.6.13",
    "framer-motion": "^6.4.2",
    "react-flatpickr": "^3.10.13",
    "swr": "2.0.1"
  },
  "peerDependencies": {
    "react": "^18.0",
    "react-dom": "^18.0",
    "viem": "~1.16.3",
    "wagmi": "~1.4.3"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/reservoirprotocol/reservoir-kit"
  }
}
